import { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


type CircleLegendProps = {
    label: string,
    color: string,
  }
  
export const CircleLegend: FunctionComponent<CircleLegendProps> = ({ label, color }) => {
    return (
        <Stack direction="row" sx={{ justifyContent: 'start' }} spacing={1}>
                <Box sx={{
                    borderRadius: '50%',
                    height: 18,
                    width: 22,
                    backgroundColor: color,
                }} />
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                }}>
                <Typography sx={{
                    padding: '0px 10px 10px 5px',
                    color: 'primary.main'
                }}>
                    {label}
                </Typography>
                </Box>
        </Stack>
    )
  }
  